<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 2C6 1.44772 6.44772 1 7 1H17C17.5523 1 18 1.44772 18 2V3H22C22.5523 3 23 3.44772 23 4V20C23 20.5523 22.5523 21 22 21H18V22C18 22.5523 17.5523 23 17 23H7C6.44772 23 6 22.5523 6 22V21H2C1.44772 21 1 20.5523 1 20V4C1 3.44772 1.44772 3 2 3H6V2ZM8 21H16V3H8V21ZM6 5H3V19H6V5ZM18 19V5H21V19H18Z" fill="currentColor" />
    </svg>
</template>
